import { Deserializable } from '../deserializable';
import { ProductEPCRating } from './product-epc-rating.model';
import { ProductSpecialFeature } from './product-special-feature.model';

export class Product implements Deserializable {
  public MonthlyRepayments?: number;
  public ProductIdAsHash: string;
  public IncludeFeesInLTV: boolean;
  public ProductID: number;
  public ArrangementFee?: number;
  public ArrangementFeeAsPercentage? = false;
  public LoanTypeCode: string;
  public ProductCode: string;
  public ProductName: string;
  public Description: string;
  public Minage?: number;
  public MaximumAge?: number;
  public StartDate?: Date;
  public WithdrawDate?: Date;
  public DateClosed?: Date;
  public MinLoanValue?: number;
  public MaxLoanValue?: number;
  public Term?: number;
  public MaximumTerm?: number;
  public MaxLtv?: number;
  public TypApr?: number;
  public ExclusiveProduct? = false;
  public BookingFee?: number;
  public BookingFeeCode?: string;
  public EarlyRedemptionCharge: string;
  public BtlFixed?: number;
  public CanCalculate? = false;
  public HigherLendingCharge? = false;
  public Rate?: number;
  public TermOther: string;
  public BtlRentalMultiplier?: number;
  public AmendedBy: string;
  public AmendedAt?: Date;
  public ProductFooter: string;
  public HasFreeLegalServiceForRemortgage? = false;
  public Kfi? = false;
  public Aip? = false;
  public App? = false;
  public IsOverrideIllustrationAllowed?: boolean;
  public ProcurationFee?: number;
  public ProcurationFeeIsPercentage? = false;
  public PropositionID?: number;
  public ExclusiveProductCompany: string;
  public FeesShouldIncludeInLTV? = false;
  public MaxLtv1?: number;
  public IsSuperseded?: boolean;
  public StatusCode: string;
  public PromotionalRateEndDate?: Date;
  public Cashback?: number;
  public CashbackIsPercentage? = false;
  public StandardValuationFeePaidByLender? = false;
  public HasFreeLegalServiceForPurchase? = false;
  public FreeLegalServiceForRemortgageTextCode: string;
  public FreeLegalServiceForPurchaseTextCode: string;
  public RequiresAdvice? = false;
  public IsForSwitchersOnly? = false;
  public IsFurtherAdvance? = false;
  public MaxLtvPAndP?: number;
  public BonusRate?: number;
  public ProductSpecialFeatures: Array<ProductSpecialFeature>;
  public IsAboutToExpire: boolean;
  public IsWithdrawn: boolean;
  public FeeCode: string;
  public ProductEPCRatings: Array<ProductEPCRating>;
  public IsTermChangeAvailable?: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    if (input.ProductSpecialFeatures) {
      this.ProductSpecialFeatures = input.ProductSpecialFeatures.map((productSpecialFeature) =>
        new ProductSpecialFeature().deserialize(productSpecialFeature)
      );
    }

    if (input.ProductEPCRatings) {
      this.ProductEPCRatings = input.ProductEPCRatings.map((productEPCRating) =>
        new ProductEPCRating().deserialize(productEPCRating)
      );
    }

    return this;
  }
}
